<template>
  <section class="nconsulting-section">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 order-lg-2">
          <div class="nconsulting-content">
            <div class="logo-badge">
              <img :src="require('@/assets/img/NetNote-Blanc.png')" alt="N'Consulting" class="logo-nconsulting">
              <span class="consulting-text">CONSULTING</span>
            </div>
            <h2 class="nconsulting-title">Accompagner l'entrepreneuriat africain avec N'Consulting</h2>
            <p class="nconsulting-description">
              À travers nos services de conseils, nous offrons un accompagnement 
              rigoureux, accessible et contextualisé aux entrepreneurs, institutions 
              et porteurs de projets afin de renforcer la performance, la clarté et 
              la durabilité de leurs initiatives
            </p>
            <div class="action-buttons">
              <CustomButton
                label="Demander un devis" 
                @click="handleDevis"
              />
              <button class="btn-video" @click="handleVideo">
                Voir la vidéo de présentation
                <i class="bi bi-play-circle-fill"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 order-lg-1">
          <div class="nconsulting-image-container">
            <img :src="require('@/assets/img/nconsulting-illustration.jpeg')" alt="Femme professionnelle" class="nconsulting-img">
            <div class="floating-icon icon-clipboard">
              <i class="bi bi-clipboard-check"></i>
            </div>
            <div class="floating-icon icon-camera">
              <i class="bi bi-camera"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import CustomButton from '@/components/CustomButton.vue';

export default {
  name: "NConsultingSection",
  components: {
    CustomButton
  },
  methods: {
    handleDevis() {
      this.$router.push('/devis');
    },
    handleVideo() {
      // Ouvrir la vidéo de présentation
      window.open('#', '_blank');
    }
  }
};
</script>

<style scoped>
.nconsulting-section {
  background: white;
  padding: 80px 0;
  position: relative;
}

.nconsulting-image-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem;
}

.nconsulting-img {
  width: 100%;
  max-width: 450px;
  height: auto;
  border-radius: 300px 300px 60px 60px;
  object-fit: cover;
  box-shadow: 0 20px 50px rgba(0,0,0,0.15);
}

.floating-icon {
  position: absolute;
  width: 50px;
  height: 50px;
  background: #2F2113;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 20px rgba(0,0,0,0.2);
}

.floating-icon i {
  font-size: 24px;
  color: white;
}

.icon-clipboard {
  top: 10%;
  left: 5%;
}

.icon-camera {
  bottom: 20%;
  right: 8%;
}

.nconsulting-content {
  padding: 2rem;
  padding-left: 3rem;
}

.logo-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #F5A847;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  margin-bottom: 1.5rem;
}

.logo-nconsulting {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

.consulting-text {
  font-size: 0.9rem;
  font-weight: 700;
  color: #2F2113;
  letter-spacing: 0.5px;
}

.nconsulting-title {
  font-size: 2.5rem;
  font-weight: 800;
  color: #1A1A1A;
  line-height: 1.15;
  margin-bottom: 1.5rem;
  letter-spacing: -0.03em;
}

.nconsulting-description {
  font-size: 1.05rem;
  color: #4A4A4A;
  line-height: 1.65;
  margin-bottom: 2rem;
  font-weight: 400;
}

.action-buttons {
  display: flex;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;
}

.btn-video {
  display: inline-flex;
  align-items: center;
  gap: 0.6rem;
  background: white;
  color: #1A1A1A;
  padding: 0.85rem 1.8rem;
  border-radius: 50px;
  border: 2px solid #1A1A1A;
  font-weight: 600;
  font-size: 0.95rem;
  transition: all 0.3s;
  cursor: pointer;
}

.btn-video:hover {
  background: #1A1A1A;
  color: white;
  transform: translateY(-2px);
}

.btn-video i {
  font-size: 1.3rem;
}

@media (max-width: 992px) {
  .nconsulting-section {
    padding: 60px 0;
  }

  .nconsulting-title {
    font-size: 2rem;
  }

  .nconsulting-content {
    padding: 2rem;
    padding-left: 2rem;
  }

  .nconsulting-img {
    max-width: 350px;
  }
}

@media (max-width: 768px) {
  .nconsulting-content {
    padding: 1rem;
    text-align: center;
  }

  .nconsulting-title {
    font-size: 1.75rem;
  }

  .nconsulting-description {
    font-size: 0.95rem;
  }

  .action-buttons {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-video {
    justify-content: center;
  }

  .logo-badge {
    justify-content: center;
  }

  .nconsulting-img {
    max-width: 300px;
  }

  .floating-icon {
    width: 40px;
    height: 40px;
  }

  .floating-icon i {
    font-size: 20px;
  }
}
</style>
